import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { SlideObject } from '../types';
import { usePresentationSettings } from '../PresentationSettingsContext';
import { hexForSettingsColor } from '../presentationSettings';
import { CHART_FONT_SIZE, CHART_GRID } from './chartModel';
import { renderChartSvg } from './chartSvg';

interface ChartObjectViewProps {
  object: SlideObject;
}

const ChartObjectView: React.FC<ChartObjectViewProps> = ({ object }) => {
  const { settings } = usePresentationSettings();
  const palette = useMemo(
    () => Object.fromEntries(settings.colors.map((color) => [color.id, color.hex])),
    [settings.colors],
  );
  const svg = renderChartSvg({
    chart: object.chart,
    width: object.w,
    height: object.h,
    palette,
    gridColor: hexForSettingsColor(settings, settings.chartDefaults?.gridColorId || 'sand', CHART_GRID),
    fontSize: settings.chartDefaults?.fontSize || CHART_FONT_SIZE,
  });

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        '& svg': { display: 'block', width: '100%', height: '100%' },
      }}
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
};

export default ChartObjectView;
